import PropTypes from 'prop-types';
import { Card, CardContent, Stack, Typography } from '@mui/material';
import Iconify from '../../../components/Iconify';

export default function AdminNoDataState({ title, description, icon = 'solar:tray-bold' }) {
  return (
    <Card variant="outlined">
      <CardContent sx={{ py: 5 }}>
        <Stack spacing={1.5} alignItems="center" textAlign="center">
          <Iconify icon={icon} sx={{ width: 42, height: 42, color: 'text.secondary' }} />
          <Typography variant="subtitle1">{title}</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 520 }}>
            {description}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}

AdminNoDataState.propTypes = {
  description: PropTypes.string.isRequired,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
};
